import { Box, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

type WhiteLabelNavigatorProps = {
  isDisabled?: boolean;
  btnNextText: string;
  nextAction?: (e?: any) => void;
  prevAction?: (e?: any) => void;
  hrefPrev: string;
};

export const WhiteLabelNavigator = ({
  isDisabled,
  btnNextText,
  nextAction,
  prevAction,
  hrefPrev
}: WhiteLabelNavigatorProps): JSX.Element => {
  return (
    <Box
      marginTop="10px !important"
      background="#FFFFFF"
      boxShadow="0 0 5px rgba(50, 50, 50, 0.25)"
      width="100%"
      height="108px"
      borderRadius="14px"
      padding="30px"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Link to={hrefPrev}>
        <Button
          background="#FFFFFF"
          border="1px solid #001E64"
          width="204px"
          height="48px"
          borderRadius="24px"
          color="#001E64"
          fontWeight="700"
          fontSize="16px"
          lineHeight="22px"
          gap="10px"
          textAlign="center"
          transition="0.2s"
          _hover={{
            bg: '#001E64',
            color: '#FFFFFF'
          }}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
          _active={{}}
        >
          Voltar
        </Button>
      </Link>
      <Button
        isDisabled={isDisabled}
        background="#FF5000"
        border="1px solid #FF5000"
        width="204px"
        height="48px"
        borderRadius="133.5px"
        color="#FFFFFF"
        fontWeight="700"
        fontSize="16px"
        lineHeight="22px"
        onClick={nextAction}
        gap="10px"
        textAlign="center"
        transition="0.2s"
        _hover={
          isDisabled
            ? {}
            : {
                bg: '#FFFFFF',
                color: '#FF5000'
              }
        }
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
        _active={{}}
      >
        {btnNextText}
      </Button>
    </Box>
  );
};
